import {
  SET_USERS,
  SET_INVITES,
  SET_PUBLISHERS,
  SET_BUYERS,
  SET_USER_VISIBLE_COLUMNS,
  SET_ERROR,
  ADD_NEW_INVITE,
} from './mutationTypes';

import { setActionStatusPending, setActionStatusSuccess, setActionStatusError } from '@/store/helpers';


export default {
  setActionStatusPending,
  setActionStatusSuccess,
  setActionStatusError,
  [SET_USERS](state, users) {
    state.users = users;
  },
  [SET_INVITES](state, invites) {
    state.invites = invites;
  },
  [SET_PUBLISHERS](state, publishers) {
    state.publishers = publishers;
  },
  [SET_BUYERS](state, buyers) {
    state.buyers = buyers;
  },
  [SET_ERROR](state, error) {
    state.error = error;
  },
  [SET_USER_VISIBLE_COLUMNS](state, userVisibleColumns) {
    state.userVisibleColumns = userVisibleColumns;
  },
  [ADD_NEW_INVITE](state, invites) {
    state.invites = [invites, ...state.invites];
  }
};